module.exports = __webpack_public_path__ + "6f8d49ddfc5c978c577bc15892704b93.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-32.png
// module id = 3090
// module chunks = 0